import { AuthState } from './auth.models';
import { authLogin, authLoginFailure, authLoginSuccess, authLogout } from './auth.actions';
import { Action, createReducer, on } from '@ngrx/store';

export const initialState: AuthState = {
  isAuthenticated: false,
  pages: []
};

const reducer = createReducer(
  initialState,
  on(authLogin, state => ({
    ...state,
    loading: true,
    error: null,
    isAuthenticated: false
  })),
  on(authLoginSuccess, (state, { isAuthenticated }) => {
    console.log(isAuthenticated);
    return {
      ...state,
      loading: false,
      isAuthenticated,
      error: null
    };
  }),
  on(authLoginFailure, (state, { isAuthenticated, error }) => ({
    ...state,
    loading: false,
    isAuthenticated,
    error
  })),
  on(authLogout, state => ({
    ...state,
    loading: false,
    error: null,
    isAuthenticated: false
  }))
);

export function authReducer(state: AuthState | undefined, action: Action): AuthState {
  return reducer(state, action);
}
